import {
  BarChart3, Truck, Target, Wrench, CheckSquare, PieChart, Users,
  ChevronLeft, ChevronRight, LogOut, FileText, SmilePlus, ClipboardCheck, FileSignature,
} from "lucide-react";
import { NAV_ITEMS, ROLE_ACCESS } from "../constants";

const ICON_MAP = { BarChart3, Truck, Target, Wrench, CheckSquare, PieChart, Users, FileText, SmilePlus, ClipboardCheck, FileSignature };

export default function Sidebar({ mod, setMod, collapsed, setCollapsed, setStageFilter, signOut, role }) {
  const allowed = ROLE_ACCESS[role] || ROLE_ACCESS.comercial;
  const visibleItems = NAV_ITEMS.filter((item) => allowed.includes(item.id));
  return (
    <div style={{
      width: collapsed ? 60 : 210, background: "#251C59",
      display: "flex", flexDirection: "column",
      transition: "width 0.2s", flexShrink: 0, overflow: "hidden",
    }}>
      {/* Logo */}
      <div style={{
        padding: collapsed ? "16px 8px" : "16px 14px",
        display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        minHeight: 64,
      }}>
        {collapsed ? (
          <img
            src="/logo-icon.png"
            alt="InstaSolutions"
            style={{ width: 40, height: 40, objectFit: "contain", flexShrink: 0 }}
          />
        ) : (
          <img
            src="/logo-horizontal-branco.png"
            alt="InstaSolutions"
            style={{ height: 68, objectFit: "contain", maxWidth: "100%" }}
          />
        )}
      </div>

      {/* Nav items */}
      <div style={{ flex: 1, padding: "8px 6px", display: "flex", flexDirection: "column", gap: 2, overflowY: "auto" }}>
        {visibleItems.map((item) => {
          const active = mod === item.id;
          const Icon = ICON_MAP[item.icon];
          return (
            <div key={item.id}>
              {item.section && !collapsed && (
                <div style={{
                  fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.35)",
                  letterSpacing: "0.1em", padding: "12px 10px 4px",
                  textTransform: "uppercase",
                }}>
                  {item.section}
                </div>
              )}
              <button
                onClick={() => { setMod(item.id); setStageFilter("all"); }}
                style={{
                  display: "flex", alignItems: "center", gap: 8,
                  padding: collapsed ? "8px 0" : "8px 10px",
                  borderRadius: 8, border: "none",
                  background: active ? "rgba(255,255,255,0.15)" : "transparent",
                  color: active ? "#FFFFFF" : "rgba(255,255,255,0.65)",
                  fontSize: 13, fontWeight: active ? 600 : 400,
                  cursor: "pointer", width: "100%",
                  justifyContent: collapsed ? "center" : "flex-start",
                  transition: "background 0.15s, color 0.15s",
                }}
              >
                {Icon && <Icon size={16} />}
                {!collapsed && item.label}
              </button>
            </div>
          );
        })}
      </div>

      {/* Logout + Collapse */}
      <div style={{ padding: "8px 6px", borderTop: "1px solid rgba(255,255,255,0.1)", display: "flex", flexDirection: "column", gap: 2 }}>
        {signOut && (
          <button
            onClick={signOut}
            style={{
              display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start", gap: 8,
              padding: collapsed ? "8px 0" : "8px 10px", borderRadius: 8, border: "none",
              background: "transparent", color: "#C02646",
              fontSize: 13, fontWeight: 500, cursor: "pointer", width: "100%",
            }}
          >
            <LogOut size={16} />
            {!collapsed && "Sair"}
          </button>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{
            display: "flex", alignItems: "center", justifyContent: "center", gap: 4,
            padding: "6px", borderRadius: 8, border: "none",
            background: "transparent", color: "rgba(255,255,255,0.4)",
            fontSize: 11, cursor: "pointer", width: "100%",
          }}
        >
          {collapsed ? <ChevronRight size={14} /> : <><ChevronLeft size={14} /><span>Recolher</span></>}
        </button>
      </div>
    </div>
  );
}
